export default function TotalHoursIcon() {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.429688 20.3112C0.492073 13.0606 5.9328 6.85552 13.4365 5.64715C18.6936 4.80062 23.2636 6.23025 27.1292 9.7281C27.5415 10.101 27.7007 10.5487 27.5213 11.0693C27.359 11.5403 26.9955 11.8196 26.4844 11.9007C26 11.9773 25.6195 11.7786 25.2801 11.4619C23.5604 9.85612 21.528 8.78871 19.1942 8.2341C12.0214 6.52994 4.62502 11.083 3.30562 18.0184C2.01878 24.7806 6.41328 31.1429 13.4629 32.5478C17.9349 33.4387 21.8764 32.274 25.2223 29.303C25.5881 28.9781 25.9671 28.7303 26.4879 28.8139C26.9982 28.8956 27.3609 29.1765 27.5229 29.6475C27.6957 30.151 27.5492 30.5891 27.1567 30.9605C25.6908 32.3473 24.006 33.4239 22.0976 34.1694C13.447 37.5467 3.697 33.0561 1.08881 24.4913C0.903593 23.8831 0.757504 23.2589 0.662957 22.6329C0.546711 21.864 0.504085 21.0856 0.429688 20.3112Z"
        fill="#505050"
      />
      <path
        d="M26.4766 23.9551L22.0734 19.7266C21.8089 19.4725 21.8089 19.0606 22.0734 18.8066L23.0314 17.8866C23.2959 17.6325 23.7249 17.6325 23.9894 17.8866L26.9556 20.7351L33.3089 14.6339C33.5734 14.3798 34.0023 14.3798 34.2669 14.6339L35.2249 15.5539C35.4894 15.8079 35.4894 16.2198 35.2249 16.4739L27.4346 23.9551C27.17 24.2091 26.7411 24.2091 26.4766 23.9551Z"
        fill="#505050"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4256 16.0066C17.4256 17.4074 17.4183 18.8082 17.4299 20.2089C17.4334 20.6525 17.2823 21.0088 16.9537 21.3215C14.8364 23.3349 12.7266 25.3558 10.6117 27.3722C10.0138 27.942 9.23452 27.972 8.69514 27.4577C8.15692 26.9449 8.18637 26.1994 8.78427 25.6267C10.7116 23.7804 12.6483 21.9427 14.5664 20.0872C14.7155 19.9429 14.8252 19.691 14.8264 19.4882C14.8438 16.8942 14.8341 14.3002 14.8399 11.7063C14.8419 10.758 15.7494 10.1383 16.6181 10.4916C17.1583 10.7114 17.4252 11.1232 17.4252 11.6878C17.4256 13.1274 17.4256 14.567 17.4256 16.0066Z"
        fill="#505050"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1446 2.9C15.0449 2.9 13.9456 2.90185 12.8459 2.89963C12.0058 2.89778 11.4199 2.39459 11.4141 1.67571C11.4079 0.941287 11.9988 0.430703 12.8637 0.429963C15.0495 0.428484 17.235 0.428114 19.4204 0.429963C20.2636 0.430703 20.8448 0.930934 20.8514 1.65278C20.858 2.38831 20.2678 2.89815 19.4026 2.89963C18.3164 2.90148 17.2303 2.9 16.1446 2.9Z"
        fill="#505050"
      />
    </svg>
  );
}
